import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    color: ${color.interface.lightGray};
    font-size: 1.1rem;
    text-align: center;
  }
`;

export const compCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${color.interface.greenSuperXtra};
  border-radius: 10px;
  padding: 10px;

  > p {
    color: ${color.interface.greenSuperXtra};
    font-size: 0.8rem;
    text-align: center;
    font-weight: 700;
  }
`;

export const compAba = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 5px;
  gap: 10px;

  > img {
    width: 30px;
    height: 30px;
    object-fit: fill;
  }

  > p {
    color: ${color.interface.darkgray};
    font-size: 0.8rem;
    text-align: center;
    font-weight: 300;
  }
`;

export const compTabs = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 5px;
  gap: 10px;
  background-color: ${color.interface.greenSuperXtra};
  border-end-start-radius: 10px;
  border-end-end-radius: 10px;

  > img {
    width: 30px;
    height: 30px;
    object-fit: fill;
  }

  > p {
    color: ${color.interface.white};
    font-size: 0.8rem;
    text-align: center;
    font-weight: 300;
  }
`;
